const handleMessageFromChildrenApp = (event: MessageEvent) => {
  if (event.data && event.data.type === "setIFrameSize") {
    const { height, width } = event.data.payload;
    resizeIFrameToFitContent(height, width);
  }
};

export const resizeIFrameToFitContent = (height: number, width: number) => {
  var iFrame = document.getElementById("app-switcher") as HTMLIFrameElement;
  if (iFrame && iFrame.contentWindow) {
    iFrame.width = width + "px";
    iFrame.height = height + "px";
  }
};

// Add compatible support for import package on server side
if (typeof window !== "undefined") {
  window.addEventListener("message", handleMessageFromChildrenApp);
  window.resizeIFrameToFitContent = resizeIFrameToFitContent;
}
